"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterTestingValveGeneratorV2 = void 0;
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const pipeNode_1 = require("../pipe/pipeNode");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const PointLocation_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocation.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
//这是随便定的
const expandLength = 500;
class WaterTestingValveGeneratorV2 {
    generate(pipeResult) {
        //找到最深的点
        let maxDepth = 0;
        let deepestNode;
        for (let nodeGroup of pipeResult._pipeNodeGroups) {
            for (let node of nodeGroup._childPipeNodes) {
                if (node._depth > maxDepth) {
                    maxDepth = node._depth;
                    deepestNode = node;
                }
            }
        }
        if (!deepestNode) {
            console.error("房间内没有管点，无法生成试水阀");
            return;
        }
        let valveNode = this.computeValvePositionAndAngle(deepestNode, pipeResult._polygonPoints);
        deepestNode.addChildNode(valveNode);
    }
    generateOnlyOnDeepestNode(rootNode, pipeResults) {
        let result = {
            //depth: 0,
            distance: 0,
            deepestNode: rootNode,
        };
        //this.traverseToGetDeepestNode(rootNode, result);
        this.traverseToGetFarthestestNode(rootNode, result);
        //找到这个node是哪个房间的
        for (let pipeResult of pipeResults) {
            for (let nodeGroup of pipeResult._pipeNodeGroups) {
                if (nodeGroup._childPipeNodes.indexOf(result.deepestNode) > -1) {
                    let valveNode = this.computeValvePositionAndAngle(result.deepestNode, pipeResult._polygonPoints);
                    result.deepestNode.addChildNode(valveNode);
                    return;
                }
            }
        }
    }
    traverseToGetDeepestNode(node, result) {
        if (node._children.length == 0 && node._depth > result["depth"]) {
            result["depth"] = node._depth;
            result["deepestNode"] = node;
        }
        for (let child of node._children) {
            this.traverseToGetDeepestNode(child, result);
        }
    }
    traverseToGetFarthestestNode(node, result) {
        if (node._children.length == 0 && node._distanceToRoot > result["distance"]) {
            result["distance"] = node._distanceToRoot;
            result["deepestNode"] = node;
        }
        for (let child of node._children) {
            this.traverseToGetFarthestestNode(child, result);
        }
    }
    computeValvePositionAndAngle(deepestNode, polygonPoints) {
        let farestPipe = new LineSegment_js_1.default(deepestNode._parent._point, deepestNode._point);
        let startPoint = new ltpoint_1.LTPoint(farestPipe.p0.x, farestPipe.p0.y);
        let endPoint = new ltpoint_1.LTPoint(farestPipe.p1.x, farestPipe.p1.y);
        //尝试延长管道，只尝试三种情况
        let expandVec = endPoint.minus(startPoint).getNormalized().dot(expandLength);
        let angle = expandVec.getAngle();
        let position = endPoint.plus(expandVec);
        let inRing = PointLocation_js_1.default.isInRing(new Coordinate_js_1.default(position.x, position.y), polygonPoints);
        if (inRing === false) {
            position = endPoint.plus(expandVec.rotate(Math.PI / 2));
            angle += Math.PI / 2;
            inRing = PointLocation_js_1.default.isInRing(new Coordinate_js_1.default(position.x, position.y), polygonPoints);
            if (inRing === false) {
                position = endPoint.plus(expandVec.rotate(Math.PI));
                angle += Math.PI;
                inRing = PointLocation_js_1.default.isInRing(new Coordinate_js_1.default(position.x, position.y), polygonPoints);
                if (inRing === false) {
                    console.error("试水阀调整失败，正常生成");
                }
            }
        }
        return new pipeNode_1.PipeNode(new Coordinate_js_1.default(position.x, position.y), pipeNode_1.PipeNodeType.Valve);
    }
}
exports.WaterTestingValveGeneratorV2 = WaterTestingValveGeneratorV2;
